<template lang="pug">
  v-layout.no-remember-password(row justify-center v-bind:class="{ wrap: $vuetify.breakpoint.md || $vuetify.breakpoint.lg, row: $vuetify.breakpoint.md || $vuetify.breakpoint.lg, column: $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }")
    v-flex(xs12)
      v-layout.not-remember-password(wrap row justify-center)
        v-flex.wrapper(xs12 sm12 md4 lg4)
          img(:src="icons.main" alt="icon_main")
          h3.omnesMedium.mt-3 ¿No son tus datos?
          h4.mt-2 Para actualizar tus datos comunícate a
            br
            |  nuestro Servicio de Atención
            br
            | (51) 500 - 0000 Opción #
      v-layout.not-remember-password(row wrap justify-center)
        v-flex.text-xs-center(xs12 sm6)
          h4.telef.omnesSemibold.mb-3(v-if="$vuetify.breakpoint.mdAndUp") (01) 500 - 0000
          v-btn.mb-4#btn-callCenterRemember(v-on:click="callToCallCenter" v-if="$vuetify.breakpoint.smAndDown") Comunicarme ahora
      v-layout(row justify-center)
        v-flex(xs12 sm12 md5)
          h3.parraf-1.text-xs-center.info--text También puedes visitar nuestras oficinas:
          h4.address.omnesMedium.text-xs-center Av. Paseo de la República 3071, San isidro
</template>

<script>

export default {
  props: ['source'],
  data () {
    return {
      loading: true,
      options: [],
      icons: {
        main: require('./../../assets/iconsv4/sac_icon.svg')
      }
    }
  },
  methods: {
    callToCallCenter () {
      document.getElementById('btnHrefTel').click()
    }
  },
  mounted () {
    if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg) {
      document.getElementsByClassName('no-remember-password row wrap')[0].style.minHeight = (window.innerHeight - document.getElementsByClassName('login__wrapper')[0].clientHeight) + 'px'
    } else {
      document.getElementsByClassName('application--wrap')[0].style.minHeight = window.innerHeight + 'px'
    }
    if (this.source === 'signup') {
      this.$gtm.trackEvent({
        event: 'RE Olvidé mis datos',
        category: 'Registro',
        action: 'REerror',
        label: 'Olvidé mis datos'
      })
    } else {
      this.$gtm.trackEvent({
        event: 'OMC Olvidé mis datos',
        category: 'Olvide mi contraseña',
        action: 'OMCerror',
        label: 'Olvidé mis datos'
      })
    }
  }
}
</script>

<style>
  .not-remember-password { margin-top: 6%; }
  .not-remember-password .wrapper { text-align: center; }
  .not-remember-password .wrapper h1 {
    font-size: 21px;
    margin-top: 1em;
  }
  .not-remember-password .wrapper img { width: 8rem; }
  .not-remember-password .wrapper p.telef {
    color: #0855C4;
    border: 1px solid #0855C4;
    border-radius: 6px;
    width: 60%;
    margin: 0 auto;
    padding: 11px 0;
  }
  .not-remember-password .wrapper p.parraf-1 { margin-top: 16px; }
  #btn-callCenterRemember {
    background-color: rgb(234,12,144) !important;
    border-color: rgb(234,12,144) !important;
    color: #FFF;
    border-radius: 12px; /* tamaño estandar */
    font-size: 19px; /* tamaño estandar */
    height: auto; /* medida estandar  */
    width: 170px; /* medida estandar  */
    padding: 12px 0;
    margin-top: 28px;
    margin-bottom: 42px!important;
  }
  #btn-callCenterRemember .v-btn__content {
    white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    white-space: pre-wrap;       /* css-3 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
    word-break: break-word;
    white-space: normal;
  }
  /* Small to large handset ----------- */
  @media only screen and (max-width : 600px) {}
  /* @media (min-width: 960px) {
    #btn-callCenterRemember {
      height: 73px;
    }
  } */

</style>



// WEBPACK FOOTER //
// src/pages/messages/NotRememberPassword.vue